import { Box, Checkbox, Text } from '@chakra-ui/react'
import type { MouseEventHandler } from 'react'

import { useOfferGrid } from '../../../context/OfferGridContext'
import type { IBodyCell, IHeaderCell } from './columnSections'
import { OfferCell } from './components/OfferCell'
import { OfferCellWrapper } from './components/OfferCellWrapper'
import { SectionBody } from './components/SectionBody'
import { SectionTitle } from './components/SectionTitle'
import type { icons } from './icons'

export interface IOfferPackageColumnSection {
  id?: string
  title?: string
  icon?: keyof typeof icons
  isOpened?: boolean
  onClick: MouseEventHandler<HTMLDivElement>
  headerCells?: Array<IHeaderCell>
  bodyCells?: Array<IBodyCell[]>
  titleBg?: string
  handleToggleAll?: (show: boolean, riskId: number) => void
  isContracted?: boolean
  titleWhenOpened?: React.ReactNode | string
}

export const OfferPackageColumnSection = ({
  id,
  title,
  icon,
  isOpened = false,
  onClick,
  headerCells,
  bodyCells,
  titleBg,
  handleToggleAll,
  isContracted,
  titleWhenOpened
}: IOfferPackageColumnSection) => {

  const { risks } = useOfferGrid()

  return (
    <Box id={id}>
      {isOpened && titleWhenOpened &&
        <SectionTitle label={titleWhenOpened} icon={icon} isOpened={isOpened} onClick={onClick} bg={titleBg} />
      }

      {!(isOpened && titleWhenOpened) &&
        <SectionTitle label={title} icon={icon} isOpened={isOpened} onClick={onClick} bg={titleBg} />
      }

      <SectionBody isOpened={isOpened}>
        {headerCells &&
          headerCells.length > 0 &&
          headerCells.map(({ id, title }) => {
            const idInt = parseInt(id)
            const riskItem = risks.find(x => x.riskId == idInt)

            return (
              <OfferCellWrapper key={id}>
                <Text sx={{ pl: '24px', fontSize: 'sm', whiteSpace: 'nowrap' }}>{title}</Text>

                {handleToggleAll &&
                  <Checkbox
                    size="sm"
                    ml='auto'
                    disabled={isContracted || !riskItem?.addable}
                    isChecked={!!riskItem?.selected}
                    onChange={e => handleToggleAll(!riskItem?.selected, idInt)}
                  />
                }
              </OfferCellWrapper>
            )
          })}

        {bodyCells &&
          bodyCells.length > 0 &&
          bodyCells.map((cell, index) => {
            if (Array.isArray(cell) && cell.length > 1) {
              return (
                <Box
                  key={index}
                  sx={{
                    display: 'grid',
                    gridTemplateColumns: `repeat(${cell.length}, 1fr)`,
                    justifyContent: 'end',
                  }}
                >
                  {cell.map((cellItem, i) => (
                    <OfferCell
                      key={i}
                      {...cellItem}
                      singleCell={false}
                    />
                  ))}
                </Box>
              )
            }

            return <OfferCell key={cell[0]?.id ?? index} {...cell[0] ?? {}} />
          })}
      </SectionBody>
    </Box >
  )
}
